// extracted by mini-css-extract-plugin
var _1 = "DeilveryUpdateTable_container__R-ssj";
var _2 = "DeilveryUpdateTable_drawerToggleButton__PopH8";
export { _1 as "container", _2 as "drawerToggleButton" }
